export default "__VITE_ASSET__CA$6RWr5__";